"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var R = _interopRequireWildcard(require("ramda"));

var _emotionTheming = require("emotion-theming");

var _styledSystem = require("styled-system");

require("@influitive/infl-fonts/fonts.css");

var _aliases = _interopRequireDefault(require("./aliases"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var extend = R.reduce(R.mergeDeepRight, {});
var sides = {
  admin: {
    colors: {
      primary: '#1883C7'
    }
  },
  advocate: {
    colors: {}
  }
};
/* stylelint-disable font-family-no-missing-generic-family-keyword */

var Base = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "e1281gho0"
})("*,*::before,*::after{box-sizing:border-box;}hr{box-sizing:content-box;height:0;overflow:visible;}font-family:", (0, _styledSystem.themeGet)('fonts.custom.fontName') || (0, _styledSystem.themeGet)('fonts.family.0'), ",\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";font-size:1rem;font-weight:normal;line-height:1.5;div[class^='Page__Container-']{width:100% !important;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aGVtZS1wcm92aWRlci9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEwQjBCIiwiZmlsZSI6Ii4uLy4uL3NyYy90aGVtZS1wcm92aWRlci9pbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgKiBhcyBSIGZyb20gJ3JhbWRhJztcbmltcG9ydCB7IFRoZW1lUHJvdmlkZXIgfSBmcm9tICdlbW90aW9uLXRoZW1pbmcnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgdGhlbWVHZXQgfSBmcm9tICdzdHlsZWQtc3lzdGVtJztcblxuaW1wb3J0ICdAaW5mbHVpdGl2ZS9pbmZsLWZvbnRzL2ZvbnRzLmNzcyc7XG5cbmltcG9ydCBtZXJnZWREZWZhdWx0cyBmcm9tICcuL2FsaWFzZXMnO1xuXG5jb25zdCBleHRlbmQgPSBSLnJlZHVjZShSLm1lcmdlRGVlcFJpZ2h0LCB7fSk7XG5cbmNvbnN0IHNpZGVzID0ge1xuICBhZG1pbjoge1xuICAgIGNvbG9yczoge1xuICAgICAgcHJpbWFyeTogJyMxODgzQzcnXG4gICAgfVxuICB9LFxuICBhZHZvY2F0ZToge1xuICAgIGNvbG9yczoge1xuXG4gICAgfVxuICB9XG59O1xuXG4vKiBzdHlsZWxpbnQtZGlzYWJsZSBmb250LWZhbWlseS1uby1taXNzaW5nLWdlbmVyaWMtZmFtaWx5LWtleXdvcmQgKi9cbmNvbnN0IEJhc2UgPSBzdHlsZWQoJ2RpdicpYFxuICAqLFxuICAqOjpiZWZvcmUsXG4gICo6OmFmdGVyIHtcbiAgICBib3gtc2l6aW5nOiBib3JkZXItYm94O1xuICB9XG5cbiAgaHIge1xuICAgIGJveC1zaXppbmc6IGNvbnRlbnQtYm94O1xuICAgIGhlaWdodDogMDtcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbiAgfVxuICBmb250LWZhbWlseTogJHt0aGVtZUdldCgnZm9udHMuY3VzdG9tLmZvbnROYW1lJykgfHwgdGhlbWVHZXQoJ2ZvbnRzLmZhbWlseS4wJyl9LCBcIkFwcGxlIENvbG9yIEVtb2ppXCIsIFwiU2Vnb2UgVUkgRW1vamlcIiwgXCJTZWdvZSBVSSBTeW1ib2xcIjtcbiAgZm9udC1zaXplOiAxcmVtO1xuICBmb250LXdlaWdodDogbm9ybWFsO1xuICBsaW5lLWhlaWdodDogMS41O1xuXG4gIGRpdltjbGFzc149J1BhZ2VfX0NvbnRhaW5lci0nXSB7XG4gICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgfVxuYDtcbi8qIHN0eWxlbGludC1lbmFibGUgZm9udC1mYW1pbHktbm8tbWlzc2luZy1nZW5lcmljLWZhbWlseS1rZXl3b3JkICovXG5cbmV4cG9ydCBkZWZhdWx0ICh7IHRoZW1lLCBjaGlsZHJlbiwgdXNlciA9ICdhZHZvY2F0ZScsIHVzZUJhc2UgPSB0cnVlIH0pID0+XG4gIDxUaGVtZVByb3ZpZGVyIHRoZW1lPXtleHRlbmQoW21lcmdlZERlZmF1bHRzLCBzaWRlc1t1c2VyXSwgdGhlbWUgfHwge31dKX0+XG4gICAge3VzZUJhc2UgPyA8QmFzZT57Y2hpbGRyZW59PC9CYXNlPiA6IGNoaWxkcmVufVxuICA8L1RoZW1lUHJvdmlkZXI+O1xuIl19 */"));
/* stylelint-enable font-family-no-missing-generic-family-keyword */

var _default = function _default(_ref) {
  var theme = _ref.theme,
      children = _ref.children,
      _ref$user = _ref.user,
      user = _ref$user === void 0 ? 'advocate' : _ref$user,
      _ref$useBase = _ref.useBase,
      useBase = _ref$useBase === void 0 ? true : _ref$useBase;
  return (0, _core.jsx)(_emotionTheming.ThemeProvider, {
    theme: extend([_aliases.default, sides[user], theme || {}])
  }, useBase ? (0, _core.jsx)(Base, null, children) : children);
};

exports.default = _default;